import script from "./RejectReson.vue?vue&type=script&lang=ts&setup=true"
export * from "./RejectReson.vue?vue&type=script&lang=ts&setup=true"

import "./RejectReson.vue?vue&type=style&index=0&id=7f045d49&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f045d49"]])

export default __exports__